import { ClassProvider } from '@angular/core'
import { HTTP_INTERCEPTORS } from '@angular/common/http'

import { AuthInterceptor } from '../interceptors/interceptor'

export const AUTH_INTERCEPTOR: ClassProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
}
